import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { openBankingFromNonSupportedLocationModal } from "@js/apps/freelancer/components/banking-from-non-supported-location-modal";
import { useEffectRef } from "@js/hooks/use-effect-ref";
import type { WithdrawalMethodType } from "@js/types/withdrawals";

export const BANKING_FROM_NON_SUPPORTED_LOCATION_QUERY_PARAM = "check_banking";

type UseOpenBankingFromNonSupportedLocationModalProps = {
  fetchingWithdrawalMethods: boolean;
  withdrawalMethods: WithdrawalMethodType[];
};

export const useOpenBankingFromNonSupportedLocationModal = ({
  fetchingWithdrawalMethods,
  withdrawalMethods,
}: UseOpenBankingFromNonSupportedLocationModalProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const paramValue = searchParams.get(
    BANKING_FROM_NON_SUPPORTED_LOCATION_QUERY_PARAM,
  );
  const paramIsSet = paramValue !== null;

  const setSearchParamsRef = useEffectRef(setSearchParams);
  useEffect(() => {
    if (!paramIsSet || fetchingWithdrawalMethods || !withdrawalMethods.length) {
      return;
    }

    const defaultWithdrawalMethod = withdrawalMethods.find(
      (method) => method.is_default,
    );

    setSearchParamsRef.current((previousParams) => {
      const searchParamsCopy = new URLSearchParams(previousParams);
      searchParamsCopy.delete(BANKING_FROM_NON_SUPPORTED_LOCATION_QUERY_PARAM);

      return searchParamsCopy;
    });

    const isWitdrawalMethodFromNonSupportedLocation =
      defaultWithdrawalMethod?.is_non_supported_location;
    if (!isWitdrawalMethodFromNonSupportedLocation) {
      return;
    }

    openBankingFromNonSupportedLocationModal();
  }, [
    paramIsSet,
    setSearchParamsRef,
    fetchingWithdrawalMethods,
    withdrawalMethods,
  ]);
};
